import * as yup from "yup";


export const addAndChangeSchema = (translate: Function) => yup.object().shape({
	ocb001Codigo: yup.string()
		.nullable(),
	ocb001Titulo: yup.string()
		.required(translate("Título é requerido"))
		.max(200, translate("Título deve conter no máximo 200 caracteres")),
	ocb001Descricao: yup.string()
		.required(translate("Descrição é requerido")),
	ocb001Data: yup.date()
		.required(translate("Data é requerido")),
	ocb001Taa001Id: yup.number()
		.required(translate("Setor é requerido")),
	ocb001Gravidade: yup.number(),
	ocb001Urgencia: yup.number(),
	ocb001Tendencia: yup.number(),
	ocb001Prioridade: yup.number(),
	ocb001Efa005Id: yup.number()
		.required(translate("Operador é requerido")),
	ocb001Oca001Id: yup.number()
		.required(translate("Requisito é requerido")),
	ocb001Oca002Id: yup.number()
		.required(translate("Origem é requerido")),
	ocb001Oca004Id: yup.number()
		.required(translate("Categoria é requerido")),
	ocb001Efa005Id4: yup.number()
		.required(translate("Responsável é requerido")),
	ocb001Efa005Id3: yup.number()
		.required(translate("Autoridade é requerido")),
	ocb001NotificaAutoridade: yup.string().oneOf(["S", "N"]),
	ocb001NotificaResponsavel: yup.string().oneOf(["S", "N"]),
	octbb002:  yup.array().of(yup.object().shape({
		ocb002Id: yup.number(),
		ocb002Ocb001Id: yup.number(),
		ocb002Oca003Id: yup.number(),
		ocb002DataFim: yup.date().required(translate("Data Final é requerida"))
			.when("ocb002DataInicio",(initialDate,schema) => {
				if (initialDate) {
					const dayBefore = new Date(initialDate.getTime() - 86400000);
					return schema.min(dayBefore, translate("Data Final tem que ser após a Data Inicial"));
				}
				return schema;
			}),
		ocb002DataInicio: yup.date()
			.required(translate("Data inicial é requerida")),
		ocb002Efa005Id: yup.number()
			.required(translate("Responsável é requerido")),
		ocb002Ordem: yup.number()
	})),
	octbb008: yup.array().of(yup.object().shape({
		ocb008Id: yup.string(),
		ocb008NotificaParticipante: yup.string(),
		ocb008Tipo: yup.string().oneOf(["C", "I"]),
		ocb008Efa005Id: yup.string(),
		ocb008Efa004Id: yup.string()
	}))
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.ocb008Efa005Id, (a: any) => !a.ocb008Efa004Id && a.ocb008Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.ocb008Efa005Id, (a: any) => !a.ocb008Efa004Id && a.ocb008Tipo === "I")
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.ocb008Efa004Id, (a: any) => !a.ocb008Efa005Id && a.ocb008Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.ocb008Efa004Id, (a: any) => !a.ocb008Efa005Id && a.ocb008Tipo === "I"),
	octbb005:  yup.array().of(yup.object().shape({
		ocb005LinkExterno: yup.string().required(translate("Link é requerido"))
	}))
});

export const addAndChangeSchemaSimplified = (translate: Function) => yup.object().shape({
	ocb001Codigo: yup.string()
		.nullable(),
	ocb001Titulo: yup.string()
		.required(translate("Título é requerido")),
	ocb001Descricao: yup.string()
		.required(translate("Descrição é requerido")),
	ocb001Data: yup.date()
		.required(translate("Data é requerido")),
	ocb001Taa001Id: yup.number()
		.required(translate("Setor é requerido")),
	ocb001Efa005Id: yup.number()
		.required(translate("Operador é requerido")),
	ocb001Oca001Id: yup.number()
		.required(translate("Requisito é requerido")),
	ocb001Oca002Id: yup.number()
		.required(translate("Origem é requerido")),
	ocb001Oca004Id: yup.number()
		.required(translate("Categoria é requerido")),
	ocb001Efa005Id4: yup.number()
		.required(translate("Responsável é requerido")),
	ocb001Efa005Id3: yup.number()
		.required(translate("Autoridade é requerido")),
	ocb001NotificaAutoridade: yup.string().oneOf(["S", "N"]),
	ocb001NotificaResponsavel: yup.string().oneOf(["S", "N"]),
	octbb008: yup.array().of(yup.object().shape({
		ocb008Id: yup.string(),
		ocb008NotificaParticipante: yup.string(),
		ocb008Tipo: yup.string().oneOf(["C", "I"]),
		ocb008Efa005Id: yup.string(),
		ocb008Efa004Id: yup.string()
	}))
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.ocb008Efa005Id, (a: any) => !a.ocb008Efa004Id && a.ocb008Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.ocb008Efa005Id, (a: any) => !a.ocb008Efa004Id && a.ocb008Tipo === "I")
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.ocb008Efa004Id, (a: any) => !a.ocb008Efa005Id && a.ocb008Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.ocb008Efa004Id, (a: any) => !a.ocb008Efa005Id && a.ocb008Tipo === "I")
});

export const registerHistorySchema = (translate: Function) => yup.object().shape({
	ocb003DataHora: yup.date()
		.required(translate("Data é requerido")),
	ocb003Aprovada: yup.string().oneOf(["S", "N", "R"]),
	ocb003Comentario: yup.string().required(translate("Comentário é requerido")),
	efficiency: yup.string().oneOf(["S", "N"]).nullable()
});


export const deleteSchema = (translate: Function) => yup.object().shape({
	ocb001Titulo: yup.string().required(translate("Titulo da ocorrência não confere")).oneOf([yup.ref("ocb001TituloConfirmation")], translate("Titulo da ocorrência não confere"))
});
